import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "gallery",
  class: "gallery-wrap pb-75"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "gallery-item-wrap style5" }
const _hoisted_4 = { class: "gallery-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "gallery-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-2" }, [
          _createElementVNode("div", { class: "section-title style3 text-center mb-40" }, [
            _createElementVNode("span", null, "Gallery Exhibition"),
            _createElementVNode("h2", null, "Discover Your Eye Health From Our Medical Clinic")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleries, (gallery) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "gallery-card style8",
            key: gallery.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: gallery.image,
                alt: "Image"
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  class: "gallery-icon",
                  to: "/gallery-details"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("i", { class: "ri-add-line" }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}